import { TmFormError } from '@/core/error/tmFormError'

export class TmFormValidatorError extends TmFormError {
  public name = 'TmFormValidatorError'
}
